import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserPlatformService {

  endpoint = environment.endpoint;

  constructor(private http: HttpClient) { }

  getAll() {
    return firstValueFrom(this.http.get(`${this.endpoint}/user-platform`));
  }

  getOne(userId: string) {
    return firstValueFrom(this.http.get(`${this.endpoint}/user-platform/${userId}`));
  }

  update(userId: string, platformIds: string[]) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/user-platform/${userId}`, { platform_ids: platformIds }));
  }

  remove(userId: string) {
    return firstValueFrom(this.http.delete(`${this.endpoint}/user-platform/${userId}`));
  }
}
